export function toTime(time, type) {
    let date = new Date(time)
    if (type === 'yyyy年MM月dd日') {
        return `${date.getFullYear()}年${(date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1)}月${date.getDate()<10?"0"+date.getDate():date.getDate()}日`
    }
    if (type === 'MM月dd日') {
        return `${(date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1)}月${date.getDate()<10?"0"+date.getDate():date.getDate()}日`
    }
    if (type === 'MM月dd日hh:mm') {
        return `${(date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1)}月${(date.getDate())<10?'0'+(date.getDate()):(date.getDate())}日\xa0${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    }
    if (type === 'yyyy-MM-dd hh:mm:ss') {
        return `${date.getFullYear()}-${(date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1)}-${date.getDate()<10?"0"+date.getDate():date.getDate()}\xa0${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    }
    if (type === 'yyyy年MM月dd日 hh:mm') {
        return `${date.getFullYear()}年${(date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1)}月${(date.getDate())<10?'0'+(date.getDate()):(date.getDate())}日\xa0${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    }
}

export function loginState() {
    if (this.Cookies.get('UserToken')) {
        return true
    } else {
        return false
    }
}

export function getWeChatCode(that, page, scene) {
    let obj = {
        page,
        scene
    }
    that.api.get('/5d5f4eb649fda', obj).then(r => {
        that.weChatCode = 'data:image/png;base64,' + r
    })
}


// WEBPACK FOOTER //
// ./src/js/common.js